import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const names = ['Martín G.', 'Sofía R.', 'Lucía P.', 'Joaquín M.', 'Camila F.', 'Mateo L.', 'Valentina S.', 'Tomás A.', 'Julieta D.', 'Agustín B.', 'Florencia C.', 'Nicolás T.', 'Micaela H.', 'Franco V.', 'Brenda O.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Posadas', 'Bariloche'];
export function ProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [timeAgo, setTimeAgo] = useState(1);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const showPopup = () => {
      setCurrentName(names[Math.floor(Math.random() * names.length)]);
      setCurrentCity(cities[Math.floor(Math.random() * cities.length)]);
      setTimeAgo(Math.floor(Math.random() * 59) + 1);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    // Interval for subsequent popups
    const interval = setInterval(() => {
      showPopup();
    }, 15000); // Every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-253">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-slate-100 p-4 flex items-start gap-4" data-id="element-254">
          <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-255">
            <X className="w-4 h-4" data-id="element-256" />
          </button>

          <div className="flex-shrink-0 mt-1" data-id="element-257">
            <CheckCircle2 className="w-8 h-8 text-emerald-500" data-id="element-258" />
          </div>

          <div className="pr-4" data-id="element-259">
            <p className="text-sm font-medium text-slate-900" data-id="element-260">
              {currentName} de {currentCity}
            </p>
            <p className="text-sm text-slate-600 mt-0.5" data-id="element-261">
              acaba de comprar ITALIANO PRO KIT
            </p>
            <p className="text-xs text-slate-400 mt-1 font-medium" data-id="element-262">
              hace {timeAgo} {timeAgo === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}